export default __webpack_public_path__ + "img/ab1437f0be976873b789da5f87c639b5.png";